jQuery(document).ready(function($) {
    'use strict';

    const $form = $('form.cart');
    const productId = window.kilamobler?.product?.id;

    if ($form.hasClass('variations_form')) {
        $form.on('show_variation', debounce(
            function(event, data) {
                $('.js-waitlist').css({
                    opacity: 0.5,
                    pointerEvents: 'none',
                });

                $.get(
                    `/?wc-ajax=fragment_waitlist&product_id=${data.variation_id}`,
                    onNewFragment,
                );
            },
            100,
            false,
        ));
    } else if (productId) {
        $.get(
            `/?wc-ajax=fragment_waitlist&product_id=${productId}`,
            onNewFragment,
        );
    }

    $(document).on('click', '#waitlist-create', function(e) {
        e.preventDefault();

        const $button = $(this);
        const product_id = $button.data('product-id');
        const email = $('#waitlist_email').val();

        if (!isEmail(email)) {
            const $form = $('#waitlist-form');
            $form.prepend(
                '<div class="email-warning hidden absolute z-[1] bottom-full left-1/2 -translate-x-1/2 w-[260px] mb-1.5 py-4 rounded-lg text-sm font-bold text-center whitespace-normal bg-tag-out-of-stock-light text-tag-out-of-stock">Du måste ange en e-postadress!</div>');
            $form.find('.email-warning').fadeIn(200);

            setTimeout(function() {
                $('.email-warning').fadeOut(200, function() {
                    $(this).remove();
                });
            }, 2000);

            return;
        }

        $button.addClass('loading');

        $.ajax({
            type: 'post',
            url: '/?wc-ajax=waitlist_create',
            data: {
                email: email,
                product_id: product_id,
            },
            success: function() {
                const swalConfig = {
                    title: 'Toppen!',
                    text: 'Du kommer få information när produkten åter finns i lager.',
                    icon: 'success',
                    type: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                };

                if (typeof swal !== 'undefined') {
                    if (swal.fire) {
                        swal.fire(swalConfig);
                    } else {
                        swal(swalConfig);
                    }

                    setTimeout(function() {
                        if (swal.close) {
                            swal.close();
                        }
                    }, 4000);
                }

                $button.removeClass('loading');
                setWaitlistProductId(product_id);

                $.get(
                    `/?wc-ajax=fragment_waitlist&product_id=${product_id}`,
                    onNewFragment,
                );
            },
        });
    });

    function onNewFragment(response) {
        $('.js-waitlist')
            .empty()
            .append(response)
            .css({opacity: 1, pointerEvents: 'all'});
    }

    function isEmail(email) {
        if (typeof email !== 'string' || !email.trim()) {
            return false;
        }

        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(email);
    }

    function getWaitlistProductIds() {
        if (typeof Cookies === 'undefined') {
            return [];
        }

        const productIds = Cookies.get('waitlist');
        return productIds ? productIds.split(',') : [];
    }

    function setWaitlistProductId(productId) {
        if (typeof Cookies === 'undefined') {
            return;
        }

        const productIds = getWaitlistProductIds();
        productIds.push(productId);
        Cookies.set('waitlist', productIds.join(','), {expires: 365});
    }

    function debounce(func, wait, immediate) {
        let timeout;
        return function(...args) {
            const context = this;
            const later = function() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }
});